const axios = require("axios");
var querystring = require("querystring");
const SKYWISE_OAUTH = "https://core.skywise.com/foundry-multipass/api/oauth2";
const COGNITO_URL =
  "https://airbus-dev-10874-2j17.auth.eu-west-1.amazoncognito.com/";
const OAUTH_CLIENT_ID = "a19a27cf3a21656b6dfe2a6c1a3d24f7";
const OAUTH_REDIRECT_URI = "https://skywise.api.dev.2j17.aws.airbus-v.cloud/client_login/";
const OAUTH_FOUNDRY_REDIRECT_URI = "https://skywise.api.dev.2j17.aws.airbus-v.cloud/oauth_login/";
const COGNITO_CLIENT_ID = "79usid8ol9vhce32j360f3ug81";
const COGNITO_CLIENT_SECRET =
  "1v6phr9dlism992l4ii1bqekgqcud1nn5tqbfmucmgk2jp6e8f0k";
const API_URL = "https://npmtzjfloe.execute-api.eu-west-1.amazonaws.com/v1-0/"
export const getObjectsFromFoundry = (auth_token, cognito_token) => {
  return axios
    .get(
      `${API_URL}extract-data`,
      {
        headers: {
          "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
          Authorization: auth_token,
          "Authorization-Cognito": cognito_token
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};

export const getDemoAirwaysAircraftObjectsFromFoundry = (auth_token, cognito_token) => {
  return axios
    .get(
      `${API_URL}demo-airways/aircraft`,
      {
        headers: {
          "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
          Authorization: auth_token,
          "Authorization-Cognito": cognito_token
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};

export const getDemoAirwaysFlightsObjectsFromFoundry = (skywiseAircraftId, auth_token, cognito_token) => {
  let url =
  `${API_URL}demo-airways/flights?skywiseAircraftId=${skywiseAircraftId}`;
  return axios
    .get(url, {
      headers: {
        "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
        Authorization: auth_token,
        "Authorization-Cognito": cognito_token
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};

export const modifyObjectsInFoundry = (form, auth_token, cognito_token) => {
  return axios
    .put(
      `${API_URL}extract-data`,
      { parameters: form },
      {
        headers: {
          "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
          Authorization: auth_token,
          "Authorization-Cognito": cognito_token
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};

export const createNewObjectsInFoundry = (form, auth_token, cognito_token) => {
  return axios
    .post(
      `${API_URL}extract-data`,
      { parameters: form },
      {
        headers: {
          "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
          Authorization: auth_token,
          "Authorization-Cognito": cognito_token
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};

export const foundryLogin = () => {
  let url_str = "https://core.skywise.com/foundry-multipass/api/oauth2/token";
  let data_st = {
    grant_type: "client_credentials",
    client_id: "a19a27cf3a21656b6dfe2a6c1a3d24f7",
    client_secret: "0d108ed5c6ca29d4747d9907fc7c5130",
  };
  return axios({
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    },
    url: url_str,
    data: querystring.stringify(data_st),
  })
    .then((result) => {
      let oauth_result = result.data;
      return oauth_result
      
    })
    .catch((error) => {
      // props.toggleLoadingAction(false);
      console.error("401-Unauthorized");
    });
};

export const cognitoLoginOAuth = (params) => {
  let url_str =
    "https://airbus-dev-10874-2j17.auth.eu-west-1.amazoncognito.com/oauth2/token";

  if (params.get("code") != null) {
    // console.log("params code", params.get("code"));
    let data_st = {
      grant_type: "authorization_code",
      client_id: COGNITO_CLIENT_ID,
      code: params.get("code"),
      scope: "profile",
      redirect_uri: OAUTH_REDIRECT_URI,
    };
    // console.log(data_st)
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      },
      url: url_str,
      data: querystring.stringify(data_st),
      auth: {
        username: COGNITO_CLIENT_ID,
        password: COGNITO_CLIENT_SECRET,
      },
    })
      .then((result) => {
        let data = result.data;
        return data;
      })
      .catch((error) => {
        console.error("401-Unauthorizes");
      });
  } else {
    if (localStorage.getItem("oauth_expires_in") !== null) {
      let expires_in_input = parseInt(localStorage.getItem("oauth_expires_in"));
      if (expires_in_input + 60 >= Date.now()) {
      } else {
        window.location = `${COGNITO_URL}/login?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${OAUTH_REDIRECT_URI}`;
      }
    } else {
      window.location = `${COGNITO_URL}/login?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${OAUTH_REDIRECT_URI}`;
    }
  }
};

export const foundryLoginOAuth = (params) => {
  let url_str = "https://core.skywise.com/foundry-multipass/api/oauth2/token";
  let data_st = {
    grant_type: "authorization_code",
    client_id: "a19a27cf3a21656b6dfe2a6c1a3d24f7",
    client_secret: "0d108ed5c6ca29d4747d9907fc7c5130",
    code: params.get("code"),
    redirect_uri: OAUTH_FOUNDRY_REDIRECT_URI,
  };
  if (params.get("code") != null) {
    // console.log("params code", params.get("code"));

    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      },
      url: url_str,
      data: querystring.stringify(data_st),
    })
      .then((result) => {
        let oauth_result = result.data;
        return oauth_result;
      })
      .catch((error) => {
        console.error("401-Unauthorized");
      });
  } else {
    if (localStorage.getItem("oauth_expires_in") !== null) {
      let expires_in_input = parseInt(localStorage.getItem("oauth_expires_in"));
      if (expires_in_input + 60 >= Date.now()) {
      } else {
        window.location = `${SKYWISE_OAUTH}/authorize?client_id=${OAUTH_CLIENT_ID}&scope=offline_access+catalog:edit+compass:edit+lime:search-index+api:read-data+api:write-data+phonograph2:write-data+phonograph2:read-data+objects-gateway:read-data+objects-gateway:write-data&response_type=code&redirect_uri=${OAUTH_FOUNDRY_REDIRECT_URI}`;
      }
    } else {
      window.location = `${SKYWISE_OAUTH}/authorize?client_id=${OAUTH_CLIENT_ID}&response_type=code&scope=offline_access+catalog:edit+compass:edit+lime:search-index+api:read-data+api:write-data+phonograph2:write-data+phonograph2:read-data+objects-gateway:read-data+objects-gateway:write-data&redirect_uri=${OAUTH_FOUNDRY_REDIRECT_URI}`;
    }
  }
};

export const deleteObjects = (data, auth_token,cognito_token) => {
  let url =
  `${API_URL}extract-data?icao=${data}`;
  return axios
    .delete(url, {
      headers: {
        "x-api-key": "ZWKcmXFsHT3QoNpEfHgQM6u2c43GRzV0ac8Cl7KT",
        Authorization: auth_token,
        "Authorization-Cognito": cognito_token
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.error("401-Unauthorized"));
};
